export default __webpack_public_path__ + "static/media/mobile-lineup.6b6521c2.svg";